/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Banner from 'components/banner';
import Layout from 'components/layout';
import style from 'styles/news/detail.module.scss';
import { action, actionServer } from 'action/index';
import Preview from 'components/preview';
import Loading from 'components/loading';
import { GetStaticProps, GetStaticPaths } from 'next';
const pcBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/pc/pc-company-dynamic-title.jpg';
const mobileBanner = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/news/mobile/m-company-dynamic-title.jpg';
const Index = (props: any) => {
  const { detail } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [count, setCount] = useState(0);
  const router = useRouter();
  if (router.isFallback) {
    return <Loading />;
  }
  const { previousNews, nextNews } = detail;

  const getPageDetail = async (id: string) => {
    if (!id) return;
    router.push(`/news/${id}`);
  };

  useEffect(() => {
    (async () => {
      const id = detail?.id;
      if (id) {
        const res = await action.getNewsViewCount(id);
        if (typeof res === 'number') {
          setCount(res || 0);
        }
      }
    })();
  }, [detail]);
  return (
    <Layout layoutClass={style.container}>
      <Head>
        <title>{detail.newsTitle || '公司新闻'}</title>
      </Head>
      <section>
        <Banner bgImage={pcBanner} bgImageMobile={mobileBanner} title="公司新闻" className={'for-pc'} />
        <Preview
          detail={{ ...detail, intro: detail.newsTitle || '', author: detail.newsAuthor || '', viewCount: undefined, enclosureList: detail.resourceList || undefined }}
          pdfPreview={true}
          classNames={style.preview}
        />
        <div className={style.page}>
          {previousNews && (
            <span className={style.pevPage} onClick={() => getPageDetail(previousNews.id)}>
              上一篇：{previousNews.newsTitle || ''}
            </span>
          )}
          {nextNews && (
            <span className={style.nextPage} onClick={() => getPageDetail(nextNews.id)}>
              下一篇：{nextNews.newsTitle || ''}
            </span>
          )}
        </div>
      </section>
    </Layout>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await actionServer.getNewsList(1, 20);
  if (!res) {
    return {
      paths: [],
      fallback: true,
    };
  }
  const paths = res.records.map((item: any) => {
    return {
      params: { id: item.id },
    };
  });
  return {
    paths,
    fallback: true,
  };
};
export const getStaticProps: GetStaticProps = async context => {
  const detail = await actionServer.getNewsDetail(context.params?.id as string);
  if (!detail) {
    return {
      revalidate: 30,
      notFound: true,
    };
  }
  return {
    props: {
      detail,
    },
    revalidate: 30,
  };
};

export default Index;
